<div 
  class="host-customer-service-client"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">
  <div class="header">
    <span class="name">
      {{ admin?.name ? admin.name + ' - ' : '' }}{{ "customer_service.title" | translate: { name: admin?.name || '' } }}
      <!-- {{ admin?.name }} - 客服 -->
    </span>
    <span
      class="close"
      (click)="close()">
      <i
        nz-icon
        nzType="close"
        nzTheme="outline"></i>
    </span>
  </div>
  <div
    class="container"
    #container>
    <div class="list">
      <host-message-item
        *ngFor="let message of listOfMessage; trackBy: trackById"
        [position]="message?.user?.role === 'admin' ? 'left' : 'right'"
        [userInfo]="message.from === admin?.id ? admin : host"
        [message]="message"
        [size]="'small'"
        (onClickGuide)="sendMessage({ type: 'text', content: $event })"></host-message-item>
    </div>
  </div>
  <div class="chat-box">
    <ng-container *ngIf="dragState !== 'dragover' else dragActive">
      <div class="toolbar">
        <nz-upload
          nzAction="/api/upload/image"
          [nzShowUploadList]="false"
          (nzChange)="onUploadChange($event)">
          <span class="upload-icon"></span>
        </nz-upload>
      </div>
      <div class="container">
        <textarea
          #chatInput
          [attr.placeholder]="'placeholder.content' | translate"
          nz-input
          [(ngModel)]="inputValue"
          (keydown)="onKeyDown($event)"
          class="box"
          autofocus></textarea>
        <button
          class="send"
          nz-button
          nzType="primary"
          (click)="sendTextMessage()"
          [disabled]="!inputValue">
          {{ "word.send" | translate }}
          <!-- 发送 -->
        </button>
      </div>
    </ng-container>
    <ng-template #dragActive>
      <div class="drag-active">
        {{ "customer_service.chatbox.drag_tip" | translate }}
        <!-- 将图片拖动到此处即可发送 -->
      </div>
    </ng-template>
  </div>

  <div
    class="visit-form"
    *ngIf="displayVisitForm">
    <div class="top">
      <p class="title">
        {{ "customer_service.anonymous.title1" | translate }}
        <!-- 您的联系方式 -->
      </p>
      <p class="subtitle">
        {{ "customer_service.anonymous.title2" | translate }}
        <!-- 一旦客服回复，我们会通过下列方式通知您 -->
      </p>
    </div>
    <div class="form">
      <div class="control" *ngIf="!isInternational">
        <input
          type="text"
          [(ngModel)]="visitForm.mobile"
          nz-input
          [attr.placeholder]="'placeholder.customer_service.phone' | translate">
      </div>
      <div class="control">
        <input
          type="text"
          [(ngModel)]="visitForm.email"
          nz-input
          [attr.placeholder]="'placeholder.customer_service.email' | translate">
      </div>
      <div class="control">
        <input
          type="text"
          [(ngModel)]="visitForm.address"
          nz-input
          [attr.placeholder]="'placeholder.customer_service.address' | translate">
      </div>
      <div class="control submit">
        <button
          nz-button
          nzBlock
          nzType="primary"
          (click)="reportVisitInfo()">
          {{ "customer_service.advisory" | translate }}
          <!-- 开始咨询 -->
        </button>
      </div>
    </div>
  </div>
</div>
